import { createSelector } from '@reduxjs/toolkit';
import type { TRootState } from 'src/store/store-types';

export const selectCampaigns = (entities: TRootState['entities']) => entities.campaigns;

export const selectCampaignList = createSelector([selectCampaigns], ({ list }) => list);

export const selectIsFetchingCampaign = createSelector([selectCampaigns], ({ isFetching }) => isFetching);

export const selectCampaignModalVisible = createSelector(
  [selectCampaigns],
  ({ campaignModalVisible }) => campaignModalVisible,
);

export const selectLearningCurveModalVisible = createSelector(
  [selectCampaigns],
  ({ learningCurveModalVisible }) => learningCurveModalVisible,
);

export const selectKpiModalVisible = createSelector([selectCampaigns], ({ kpiModalVisible }) => kpiModalVisible);

export const selectHierarchyTableModalVisible = createSelector(
  [selectCampaigns],
  ({ welldesignModalVisible }) => welldesignModalVisible,
);

export const selectCampaignDesigns = createSelector([selectCampaigns], ({ designs }) => designs);

export const selectIsAddingCampaigns = createSelector([selectCampaigns], ({ isAdding }) => isAdding);

export const selectCampaignEstimates = createSelector([selectCampaigns], ({ estimates }) => estimates);

export const selectCampaignTotal = createSelector([selectCampaigns], ({ campaignTotal }) => campaignTotal);

export const selectIsFetchingCampaignResults = createSelector(
  [selectCampaigns],
  ({ isFetchingCampaignResults }) => isFetchingCampaignResults,
);

export const selectIsRecalculatingCampaigns = createSelector(
  [selectCampaigns],
  ({ isRecalculating }) => isRecalculating,
);

export const selectIsGeneratingCampaignEstimates = createSelector(
  [selectCampaigns],
  ({ isGeneratingEstimates }) => isGeneratingEstimates,
);

export const selectActiveCampaign = createSelector([selectCampaignList], (campaign) =>
  campaign.find((item) => item.active),
);

export const selectActiveEstimates = createSelector(
  [selectCampaignEstimates, selectActiveCampaign],
  (estimates, activeCampaign) =>
    estimates.filter((item) => item.campaignId === activeCampaign?.campaignId && item.visible !== false),
);

export const selectConceptDesigns = createSelector([selectActiveCampaign], (activeCampaign) =>
  activeCampaign ? activeCampaign.designs : [],
);
